import { useEffect, useState } from "react";
import { SearchAndSelectEntryList } from "@kaltura/mediaspace-shared-types";

export function useManagePlaylistData(
    searchData: Record<string, any>,
    pageSize: number,
    fullList?: SearchAndSelectEntryList
): SearchAndSelectEntryList | undefined {
    const [response, setResponse] = useState<SearchAndSelectEntryList>();

    useEffect(() => {
        // fullList
        let filteredList = fullList?.objects ?? [];

        // filter by search data
        if (searchData.keyword) {
            const byName = filteredList.filter((entry) =>
                entry.entry.name.toLowerCase().includes(searchData.keyword.toLowerCase())
            );
            const byDescription = filteredList.filter((entry) =>
                entry.entry.description?.toLowerCase().includes(searchData.keyword.toLowerCase())
            );
            const byTags = filteredList.filter((entry) =>
                entry.entry.tags?.toLowerCase().includes(searchData.keyword.toLowerCase())
            );
            filteredList = Array.from(new Set([...byName, ...byDescription, ...byTags]));
        }

        // sort by search data
        switch (searchData.sortBy) {
            case "name":
                filteredList = filteredList.sort((a, b) => a.entry.name.localeCompare(b.entry.name));
                break;
            case "-name":
                filteredList = filteredList.sort((a, b) => b.entry.name.localeCompare(a.entry.name));
                break;
            case "createdAtAsc":
                filteredList = filteredList.sort((a, b) => a.entry.createdAt - b.entry.createdAt);
                break;
            case "recent":
                filteredList = filteredList.sort((a, b) => b.entry.createdAt - a.entry.createdAt);
                break;
            case "updatedAtAsc":
                filteredList = filteredList.sort((a, b) => a.entry.updatedAt - b.entry.updatedAt);
                break;
            case "updatedAtDesc":
                filteredList = filteredList.sort((a, b) => b.entry.updatedAt - a.entry.updatedAt);
                break;
        }

        // slice by page
        const start = (searchData.page - 1) * pageSize;
        const end = start + pageSize;
        filteredList = filteredList.slice(start, end);
        setResponse({ objects: filteredList, totalCount: fullList?.totalCount ?? 0 });
    }, [fullList, pageSize, searchData]);

    return response;
}
